// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import CoteDivoire from '../_raw/flag/icon_flag_cote_divoire.png';

export default () => <img src={CoteDivoire} alt="CoteDivoire" />;
